import * as yup from "yup";
import { alphaNumericPattern, emailrgx } from "../assets/constant";
import { useTranslation } from "react-i18next";

import { countries } from "../assets/nationalities"; 
export const schema = (t) => yup
  .object({
    companyname: yup
      .string()
      .trim()
      .matches(alphaNumericPattern, t("Please enter a valid company name"))
      .required(t("Please enter the company name")),



    region: yup
      .string()
      .required(t("Country is required"))
    

      .oneOf(
        countries,
        t("Invalid Country selected")
      ),


    name: yup
      .string()
      .trim()
      .matches(alphaNumericPattern, t("Please enter a valid name"))
      .required(t("Please enter your name")),



    phone: yup.string().trim().matches(/^\+\d{1,4}\d{6,14}$/, t("Please enter a valid international phone number that starts with +")).required(t("Contact number is required")),

    street: yup
      .string()
      .trim()
      .required(t('Street is required'))
      .min(2, t('Street / Building / House No, must be at least 2 characters')),

    postal_code: yup
      .string()
      .trim()
      .required(t('Postal Code is required'))
      .matches(/^\d{4,6}$/, t('Postal Code must be 4 to 6 digits')),





  })
  .required();
  export const schemaAgencyPlus = (t) => yup
  .object({


    employment_registration: yup
      .string()
      .trim()
      .matches(alphaNumericPattern, t("Please enter a valid Employment Registration"))
      .required(t("Please enter a valid Employment Registration")),

    registration_number: yup
      .string()
      .trim()
      .matches(alphaNumericPattern, t("Please enter a valid Registration Number"))
      .required(t("Please enter a valid Registration Number")),

  })
  .required();
